import { render, staticRenderFns } from "./CustomerItem.vue?vue&type=template&id=cf703d6a&"
import script from "./CustomerItem.vue?vue&type=script&lang=js&"
export * from "./CustomerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports